export const getFuelLevyLabels = (label: string) => {
	switch (label) {
	case 'additional_drop_off_stops':
		return 'Additional drop-off';
	case 'additional_pickup_stops':
		return 'Additional pick-up';
	case 'admin_fee':
		return 'Admin fee';
	case 'dangerous_goods':
		return 'Dangerous goods';
	case 'day_surcharges':
		return 'Day surcharges';
	case 'demurrage':
		return 'Demurrage';
	case 'express':
		return 'Express';
	case 'forklift':
		return 'Forklift';
	case 'hand_unload':
		return 'Hand unload';
	case 'pallet_exchange':
		return 'Pallet exchange';
	case 'pallet_jack':
		return 'Pallet jack';
	case 'pallet_transfer':
		return 'Pallet transfer';
	case 'split_trailer':
		return 'Split trailer';
	case 'tailgate_lift':
		return 'Tailgate lift';
	case 'time_slot':
		return 'Time slot';
	case 'tolls':
		return 'Tolls';
	case 'truck_type':
		return 'Truck type';
	case 'admin_standard_booking_fee':
		return 'Admin standard booking fee';
	default:
		return label;
	}
}